import axios, { AxiosResponse } from 'axios';
import { BlogResponse } from '../types/api/blogApi';

const API_URL = process.env.REACT_APP_API_URL;

const customHeaders = {
    'Content-Type': 'application/json'
};

// typed parameters and response
export const getArticlesService = async (): Promise<AxiosResponse<BlogResponse>> => {
    try {
        const response = await axios.get(API_URL + 'article', { headers: customHeaders });
        return response;
    } catch (error: any) {
        console.error('Error fetching auth:', error);
        // You can toast an error message if needed
        // toast.error(error?.response?.data?.msg);
        throw error;
    }
};

// typed parameters and response
export const getArticleService = async (): Promise<AxiosResponse<BlogResponse>> => {
    try {
        const response = await axios.get(API_URL + 'article', { headers: customHeaders });
        return response;
    } catch (error: any) {
        console.error('Error fetching auth:', error);
        // You can toast an error message if needed
        // toast.error(error?.response?.data?.msg);
        throw error;
    }
};

